import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-sad-icon',
  templateUrl: './general-sad.component.html'
})
export class GeneralSadComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
